import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { Button } from '@mui/material'
import { messages } from '../../../../messages'


export default function EndDraftDialog({ open, setOpen, onConfirm }) {

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">Ending Draft</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messages[12].consentToEndDraft}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button id='draftEndBtn' onClick={onConfirm}>Confirm</Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
